module.exports = __webpack_public_path__ + "static/media/apple-pay-mark.fe4f01ad.svg";